import { createUseStyles } from 'react-jss';

import { ITheme, mediaQuery } from '../../../styles';

import { SliderBackground } from './types';

export default createUseStyles<string, { background: SliderBackground }>(
  ({ breakpoints }: ITheme) => ({
    content: {
      backgroundColor: '#fff',
      borderRadius: 32,
      padding: [32, 40],

      [mediaQuery(breakpoints.tablet)]: {
        padding: [32, 24],
      },
    },
    title: {
      color: 'var(--x-accent-1-1)',
      fontSize: 30,
      fontWeight: 600,
      lineHeight: '36px',
      marginBottom: 12,
      textAlign: 'center',
    },
    description: {
      color: 'var(--x-black-1)',
      textAlign: 'center',
    },
  }),
  {
    name: 'SliderFrame',
  },
);
